import { Drawer } from "antd";
import { observer } from "mobx-react-lite";
import TemplateEditForm from "../pages/settings-page/components/TemplateEditForm";
import { useTranslation } from 'react-i18next';

/* eslint-disable-next-line */
export interface EditTemplateDialogProps {
  onClose: () => void;
}

// Content component that uses the templates namespace
function EditTemplateDialog({ onClose }: EditTemplateDialogProps) {
  const { t } = useTranslation('templates', { useSuspense: false });
  return (
    <Drawer
      title={t('dialog.editTitle')}
      width={"75vw"}
      closable={true}
      onClose={onClose}
      open={true}
    >
      <TemplateEditForm onSave={onClose} />
    </Drawer>
  );
}

export default observer(EditTemplateDialog);
